export default __webpack_public_path__ + "static/media/showcase-incidents.7f60311b.jpg";